import PipelineEvent from './PipelineEvent';

export default PipelineEvent;
